export const cronMonitor = {
  title: 'Scheduled Tasks Monitor',
  menuLabel: 'Task Monitor',
  buttons: {
    runNow: 'Run Now',
    refresh: 'Refresh',
  },
  sections: {
    cronJobInfo: 'Cron Job Information',
    upcomingChanges: 'Upcoming Changes',
    recentExecutions: 'Recent Executions',
  },
  fields: {
    schedule: 'Schedule',
    nextRun: 'Next Run',
    lastRun: 'Last Run',
    template: 'Template',
    effectiveDate: 'Effective Date',
    status: 'Status',
    reason: 'Reason',
    createdBy: 'Created By',
    executionTime: 'Execution Time',
    applied: 'Applied',
    errors: 'Errors',
  },
  status: {
    success: 'Success',
    partialSuccess: 'Partial Success',
    failed: 'Failed',
    overdue: 'OVERDUE',
    readyToApply: 'Ready to apply',
  },
  messages: {
    noExecutionsYet: 'No executions yet',
    noUpcomingChanges: 'No upcoming changes scheduled',
    noExecutionHistory: 'No execution history available',
    failedToLoad: 'Failed to load cron status',
    cronTriggeredSuccess: 'Cron job triggered successfully',
    cronTriggerFailed: 'Failed to trigger cron job',
    appliedWithErrors: '%{applied} applied, %{errors} errors',
    inHours: 'In %{hours} hours',
  },
};
